// extracted by mini-css-extract-plugin
export var divider = "_gm-7";
export var itemsToggle = "_gm-8";
export var mergeModal = "_gm-1";
export var optionCard = "_gm-4";
export var radioGroup = "_gm-6";
export var radioOption = "_gm-0";
export var selected = "_gm-5";
export var shipmentOptions = "_gm-2";
export var tableOptions = "_gm-3";